const shared = {
  "shared-notfound-title": "該当するデータが存在しません",
  "shared-notfound-desc":
    "絞り込み条件を再確認するか、データをアップロードして設定を完了してください。",

  "shared-reload-button1": "リロード",
  "shared-reload-button2": "リロード中...",
  "shared-create-button1": "新規作成",
  "shared-create-button2": "新規作成中...",

  "shared-fetch-api-success": "データの取得が正常に行われました。",
  "shared-fetch-api-loading": "データの取得中です。",
  "shared-fetch-api-error": "データの取得に失敗しました。",

  "shared-reload-api-success": "データの最新化が正常に行われました。",
  "shared-reload-api-loading": "データの最新化中です。",
  "shared-reload-api-error": "データの最新化に失敗しました。",

  "shared-401-error-title": "セッションの有効期限が切れました",
  "shared-401-error-caption":
    "引き続きサービスをご利用いただくには、再度ログインしてください。",
  "shared-401-error-submit": "ログイン",

  "shared-400-error-title": "入力エラー",
  "shared-400-error-caption":
    "利用可能なデータが存在しません、絞り込み条件を再確認の上、再度お試しください。",
  "shared-400-error-submit": "OK",

  "shared-422-error-title": "処理不能なコンテンツエラー",
  "shared-422-error-caption":
    "利用可能なデータが存在しません、データのアップロードおよび初期設定を完了させてください。",
  "shared-422-error-submit": "データ管理ページへ",

  "shared-500-error-title": "インターサーバーエラー",
  "shared-500-error-caption":
    "大変申し訳ございません。現在、サーバーで予期せぬエラーが発生しており、データの読み込みに失敗しました。しばらく時間をおいてから、再度お試しください。",
  "shared-500-error-submit": "OK",

  "shared-502-error-title": "バッドゲートウェイ",
  "shared-502-error-caption":
    "大変申し訳ございません。現在、サーバーで予期せぬエラーが発生しており、データの読み込みに失敗しました。しばらく時間をおいてから、再度お試しください。",
  "shared-502-error-submit": "OK",

  "shared-graph-average": "平均",

  "shared-query-button": "フィルタ",
  "shared-query-title": "フィルタ",

  // モデル同時更新確認ダイアログ
  "shared-model-sync-confirm-title": "モデルの同時更新",
  "shared-model-sync-confirm-body": "RCA・CATEのモデルを同時に更新しますか？",
  "shared-model-sync-yes": "はい",
  "shared-model-sync-no": "このページのみ",

  "shared-time-range-from": "開始時刻",
  "shared-time-range-to": "終了時刻",
  "shared-dropdown-please-select": "選択してください。",
  "shared-dropdown-selected": "選択中",
  "shared-dropdown-all-select": "全選択",
  "shared-dropdown-no-filter": "フィルタなし",
  "shared-dropdown-empty": "該当結果なし。",
  "shared-dropdown-submit": "反映",
  "shared-dropdown-clear": "クリア",

  "shared-input-please-enter": "入力してください。",
  "shared-input-search-by": "検索する",

  "shared-table-filter-status": "ステータス",

  "shared-table-header-asc": "昇順",
  "shared-table-header-desc": "降順",

  "shared-table-pagination-selected": "行 選択中",
  "shared-table-pagination-rows-per-page": "ページごとの行数",
  "shared-table-pagination-page": "ページ",

  "shared-table-button-selected": "選択中",
  "shared-table-button-submit": "反映",
  "shared-table-button-edit": "編集",
  "shared-table-button-active": "有効化",
  "shared-table-button-inactive": "無効化",
  "shared-table-button-delete": "削除",
  "shared-table-button-mfa": "MFAリセット",
  "shared-table-button-share": "共有",
  "shared-table-button-save": "保存",
  "shared-table-button-export": "エクスポート",
  "shared-table-button-download": "ダウンロード",

  "copied-success": "正常にコピーできました。",
  "download-success": "正常にダウンロードできました。",

  active: "有効化中",
  inactive: "無効化中",
  pending: "保留中",
  deleted: "削除済み",

  using: "使用中",
  unused: "未使用",

  selected: "選択中",
  unselected: "未選択",

  missing_edge: "エッジ未指定",
  not_found_edge: "エッジ未存在",
  duplicate_edges: "重複エッジ",
  incoming_edges: "入力エッジ上限違反",
  layer_rule: "レイヤールール違反",
  cycle_rule: "循環接続違反",

  query_bar: {
    time_grain: "粒度",
    time_range: "レンジ",
  },
  queue_panel: {
    empty: "現在、処理中のキューはありません。",
  },
  menu_panel: {
    slug: {
      assistant: "アシスタント",
      dashboard: "ダッシュボード",
      graph: "因果グラフ",
      rca: "RCA",
      cate: "CATE",
      simulation: "シミュレーション",
      data_manager: "データ管理",
      augmentation: "データ拡張",
      account: "アカウント",
      docs: "ドキュメント",
      terms: "利用規約",
      policy: "プライバシーポリシー",
    },
    theme: {
      index: "テーマ",
      light: "ライト",
      dark: "ダーク",
    },
    lang: {
      index: "言語",
      locale: "日本語",
    },
    auth: {
      login: "ログイン",
      logout: "ログアウト",
    },
  },
  project_panel: {
    api: {
      success: "プロジェクトが正常に切り替わりました。",
      error: "プロジェクトの切り替えに失敗しました。",
    },
    header: "プロジェクト",
    please_select: "選択してください。",
    empty: "該当結果なし。",
    submit: "反映",
  },
  header: {
    docs: "ドキュメント",
    logout: "ログアウト",
    login: "ログイン",
    lng: "EN",
  },
  footer: {
    top: "トップ",
    faq: "FAQ",
    docs: "ドキュメント",
    inquiry: "お問い合わせ",
    terms: "利用規約",
    policy: "プライバシーポリシー",
    security: "情報セキュリティ方針",
    corp: "企業サイト",
  },
  datetime: {
    just_now: "たった今",
    seconds_ago: "{{count}} 秒前",
    minutes_ago: "{{count}} 分前",
    hours_ago: "{{count}} 時間前",
    days_ago: "{{count}} 日前",
  },
  store_type: {
    add: "追加",
    new: "新規",
  },
  imput_type: {
    liner: "線形補完",
    zero: "ゼロ補完",
  },
  display: {
    display: "表示",
    hide: "非表示",
  },
  status: {
    idle: "待機中",
    loading: "処理中",
    success: "完了",
    error: "失敗",
    unknown: "不明",
  },
  upload_status: {
    idle: "アップロード待機中",
    loading: "アップロード中",
    success: "アップロード完了",
    error: "アップロード失敗",
    unknown: "不明",
  },
};

export default shared;
